export const SET_LOGGED_IN = 'SET_LOGGED_IN'
export const UNSET_LOGGED_IN = 'UNSET_LOGGED_IN'
export const SET_MESSAGE = 'SET_MESSAGE'
export const UNSET_MESSAGE = 'UNSET_MESSAGE'
export const SET_AUTH_USER = 'SET_AUTH_USER'
export const UNSET_AUTH_USER = 'UNSET_AUTH_USER'
export const SET_USER_ROLE_DATA = 'SET_USER_ROLE_DATA'
export const SET_USER_ROLE = 'SET_USER_ROLE'
export const SET_USER_TYPE = 'SET_USER_TYPE'
export const SET_ACCESS_MENU_LINK = 'SET_ACCESS_MENU_LINK'


//-------------------Not Usable tag----------------------
export const USERINFO_UNSET_SCHEMA = 'USERINFO_UNSET_SCHEMA'
export const USERINFO_UNSET_LIST_DATA = 'USERINFO_UNSET_LIST_DATA'
export const USERINFO_SET_LIST_DATA = 'USERINFO_SET_LIST_DATA'
export const USERINFO_SET_ACTION_PROCESS = 'USERINFO_SET_ACTION_PROCESS'
export const USERINFO_UNSET_ACTION_PROCESS = 'USERINFO_UNSET_ACTION_PROCESS'
export const USERINFO_UNSET_ALL_STATE = 'USERINFO_UNSET_ALL_STATE'
export const USERINFO_SET_ACTION_STATUS = 'USERINFO_SET_ACTION_STATUS'
export const USERINFO_UNSET_ACTION_STATUS = 'USERINFO_UNSET_ACTION_STATUS'
export const USERINFO_SET_MSG = 'USERINFO_SET_MSG'
export const USERINFO_UNSET_MSG = 'USERINFO_UNSET_MSG'
export const USERINFO_SET_SCHEMA = 'USERINFO_SET_SCHEMA'
//-------------------/Not Usable tag----------------------

//------------ Table Name sysMenu  -------------
export const SYSMENU_UNSET_ALL_STATE = 'SYSMENU_UNSET_ALL_STATE'
export const SYSMENU_SET_MSG = 'SYSMENU_SET_MSG'
export const SYSMENU_UNSET_MSG = 'SYSMENU_UNSET_MSG'
export const SYSMENU_SET_SCHEMA = 'SYSMENU_SET_SCHEMA'
export const SYSMENU_UNSET_SCHEMA = 'SYSMENU_UNSET_SCHEMA'
export const SYSMENU_SET_ACTION_PROCESS = 'SYSMENU_SET_ACTION_PROCESS'
export const SYSMENU_UNSET_ACTION_PROCESS = 'SYSMENU_UNSET_ACTION_PROCESS'
export const SYSMENU_SET_LIST_DATA = 'SYSMENU_SET_LIST_DATA'
export const SYSMENU_UNSET_LIST_DATA = 'SYSMENU_UNSET_LIST_DATA'
export const SYSMENU_SET_ACTION_STATUS = 'SYSMENU_SET_ACTION_STATUS'
export const SYSMENU_UNSET_ACTION_STATUS = 'SYSMENU_UNSET_ACTION_STATUS'


//------------ Table Name sysSubmenu  -------------
export const SYSSUBMENU_UNSET_ALL_STATE = 'SYSSUBMENU_UNSET_ALL_STATE'
export const SYSSUBMENU_SET_MSG = 'SYSSUBMENU_SET_MSG'
export const SYSSUBMENU_UNSET_MSG = 'SYSSUBMENU_UNSET_MSG'
export const SYSSUBMENU_SET_SCHEMA = 'SYSSUBMENU_SET_SCHEMA'
export const SYSSUBMENU_UNSET_SCHEMA = 'SYSSUBMENU_UNSET_SCHEMA'
export const SYSSUBMENU_SET_ACTION_PROCESS = 'SYSSUBMENU_SET_ACTION_PROCESS'
export const SYSSUBMENU_UNSET_ACTION_PROCESS = 'SYSSUBMENU_UNSET_ACTION_PROCESS'
export const SYSSUBMENU_SET_LIST_DATA = 'SYSSUBMENU_SET_LIST_DATA'
export const SYSSUBMENU_UNSET_LIST_DATA = 'SYSSUBMENU_UNSET_LIST_DATA'
export const SYSSUBMENU_SET_ACTION_STATUS = 'SYSSUBMENU_SET_ACTION_STATUS'
export const SYSSUBMENU_UNSET_ACTION_STATUS = 'SYSSUBMENU_UNSET_ACTION_STATUS'

//------------ Table Name sysUsergrantRole  -------------
export const SYSUSERGRANTROLE_UNSET_ALL_STATE = 'SYSUSERGRANTROLE_UNSET_ALL_STATE'
export const SYSUSERGRANTROLE_SET_MSG = 'SYSUSERGRANTROLE_SET_MSG'
export const SYSUSERGRANTROLE_UNSET_MSG = 'SYSUSERGRANTROLE_UNSET_MSG'
export const SYSUSERGRANTROLE_SET_SCHEMA = 'SYSUSERGRANTROLE_SET_SCHEMA'
export const SYSUSERGRANTROLE_UNSET_SCHEMA = 'SYSUSERGRANTROLE_UNSET_SCHEMA'
export const SYSUSERGRANTROLE_SET_ACTION_PROCESS = 'SYSUSERGRANTROLE_SET_ACTION_PROCESS'
export const SYSUSERGRANTROLE_UNSET_ACTION_PROCESS = 'SYSUSERGRANTROLE_UNSET_ACTION_PROCESS'
export const SYSUSERGRANTROLE_SET_LIST_DATA = 'SYSUSERGRANTROLE_SET_LIST_DATA'
export const SYSUSERGRANTROLE_UNSET_LIST_DATA = 'SYSUSERGRANTROLE_UNSET_LIST_DATA'
export const SYSUSERGRANTROLE_SET_ACTION_STATUS = 'SYSUSERGRANTROLE_SET_ACTION_STATUS'
export const SYSUSERGRANTROLE_UNSET_ACTION_STATUS = 'SYSUSERGRANTROLE_UNSET_ACTION_STATUS'

//------------ Table Name sysUserrole  -------------
export const SYSUSERROLE_UNSET_ALL_STATE = 'SYSUSERROLE_UNSET_ALL_STATE'
export const SYSUSERROLE_SET_MSG = 'SYSUSERROLE_SET_MSG'
export const SYSUSERROLE_UNSET_MSG = 'SYSUSERROLE_UNSET_MSG'
export const SYSUSERROLE_SET_SCHEMA = 'SYSUSERROLE_SET_SCHEMA'
export const SYSUSERROLE_UNSET_SCHEMA = 'SYSUSERROLE_UNSET_SCHEMA'
export const SYSUSERROLE_SET_ACTION_PROCESS = 'SYSUSERROLE_SET_ACTION_PROCESS'
export const SYSUSERROLE_UNSET_ACTION_PROCESS = 'SYSUSERROLE_UNSET_ACTION_PROCESS'
export const SYSUSERROLE_SET_LIST_DATA = 'SYSUSERROLE_SET_LIST_DATA'
export const SYSUSERROLE_UNSET_LIST_DATA = 'SYSUSERROLE_UNSET_LIST_DATA'
export const SYSUSERROLE_SET_ACTION_STATUS = 'SYSUSERROLE_SET_ACTION_STATUS'
export const SYSUSERROLE_UNSET_ACTION_STATUS = 'SYSUSERROLE_UNSET_ACTION_STATUS'

//------------ Table Name sysUserroleDet  -------------
export const SYSUSERROLEDET_UNSET_ALL_STATE = 'SYSUSERROLEDET_UNSET_ALL_STATE'
export const SYSUSERROLEDET_SET_MSG = 'SYSUSERROLEDET_SET_MSG'
export const SYSUSERROLEDET_UNSET_MSG = 'SYSUSERROLEDET_UNSET_MSG'
export const SYSUSERROLEDET_SET_SCHEMA = 'SYSUSERROLEDET_SET_SCHEMA'
export const SYSUSERROLEDET_UNSET_SCHEMA = 'SYSUSERROLEDET_UNSET_SCHEMA'
export const SYSUSERROLEDET_SET_ACTION_PROCESS = 'SYSUSERROLEDET_SET_ACTION_PROCESS'
export const SYSUSERROLEDET_UNSET_ACTION_PROCESS = 'SYSUSERROLEDET_UNSET_ACTION_PROCESS'
export const SYSUSERROLEDET_SET_LIST_DATA = 'SYSUSERROLEDET_SET_LIST_DATA'
export const SYSUSERROLEDET_UNSET_LIST_DATA = 'SYSUSERROLEDET_UNSET_LIST_DATA'
export const SYSUSERROLEDET_SET_ACTION_STATUS = 'SYSUSERROLEDET_SET_ACTION_STATUS'
export const SYSUSERROLEDET_UNSET_ACTION_STATUS = 'SYSUSERROLEDET_UNSET_ACTION_STATUS'


//------------------BB_MODULE---------------------
export const SET_MODULE_NAME = 'SET_MODULE_NAME'
export const SET_PROJECT_INFO = 'SET_PROJECT_INFO'
export const SEARCH_DISBURSEMENT_DATA = 'SEARCH_DISBURSEMENT_DATA'
export const UNSET_SEARCH_DISBURSEMENT_DATA = 'UNSET_SEARCH_DISBURSEMENT_DATA'

export const SET_KEY_VALUE = 'SET_KEY_VALUE'
export const UNSET_KEY_VALUE = 'UNSET_KEY_VALUE'

export const  SET_RE_PAYMENT_DATA = 'SET_RE_PAYMENT_DATA'
export const  UNSET_RE_PAYMENT_DATA = 'UNSET_RE_PAYMENT_DATA'

export const  SET_COMMON_DATA = 'SET_COMMON_DATA'
export const  UNSET_COMMON_DATA = 'UNSET_COMMON_DATA'

export const SET_VOUCHER_ENTRY_DATA = 'SET_VOUCHER_ENTRY_DATA'
export const UNSET_VOUCHER_ENTRY_DATA = 'UNSET_VOUCHER_ENTRY_DATA'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js